import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ipp",
  "use": "icon-ipp-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-ipp\"><path d=\"M341.333333 170.666667h554.666667v85.333333H341.333333V170.666667z m-213.333333-21.333334h128v128H128v-128z m0 298.666667h128v128H128v-128z m0 298.666667h128v128H128v-128zM341.333333 469.333333h554.666667v85.333334H341.333333v-85.333334z m0 298.666667h554.666667v85.333333H341.333333v-85.333333z\" fill=\"#ffffff\" p-id=\"1200\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol